import { EStudentPaymentStatus } from '@constants';
import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ChangeStatusConfirmationWrapper, TitleWrapper } from './ChangeStatusInBulkModal.styles';
import { CustomTagSelector } from './CustomTagSelector';

import { useMutateStudentPaymentStatus } from '@/store';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedRowKeys: React.Key[];
  setSelectedRowKeys: (selectedRowKeys: React.Key[]) => void;
};

export const ChangeStatusInBulkModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  selectedRowKeys,
  setSelectedRowKeys
}) => {
  const { t } = useTranslation();
  const [newStudentStatus, setNewStudentStatus] = useState<EStudentPaymentStatus | null>(null);
  const { changePaymentStatusInBulk, isWorking } = useMutateStudentPaymentStatus();

  const handleChangeStatus = () => {
    if (!newStudentStatus) return;
    changePaymentStatusInBulk(
      {
        studentIds: selectedRowKeys.map(key => key.toString()),
        status: newStudentStatus
      },
      {
        onSuccess: () => {
          setIsOpen(false);
          setNewStudentStatus(null);
          setSelectedRowKeys([]);
        }
      }
    );
  };

  return (
    <Modal open={isOpen} onCancel={() => setIsOpen(false)} title={t('CHANGE_STATUS')} footer={null}>
      <ChangeStatusConfirmationWrapper>
        <TitleWrapper>
          {t('CHANGE_STATUS_CONFIRMATION', { count: selectedRowKeys.length })}
        </TitleWrapper>
        <CustomTagSelector
          selectedStatus={newStudentStatus}
          setSelectedStatus={setNewStudentStatus}
        />
        <Button
          loading={isWorking}
          type="primary"
          onClick={handleChangeStatus}
          disabled={!newStudentStatus || isWorking}>
          {t('SAVE')}
        </Button>
      </ChangeStatusConfirmationWrapper>
    </Modal>
  );
};
